export default __webpack_public_path__ + "media/images/orig-logo-symbol-wordmark-93376204dad72a84a9fa21283953e497.svg";